import { _API, _AXIOS_HELPER, _HEADER } from '@/static';
import * as ENUM from "@/enum/lib";

export default {
    getProductList() {
        return new Promise( ( resolve, reject ) => {
            const url = _API + '/payment/getProductList';
            const conf = {
                headers: _HEADER()
            };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, {}, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        } );
    },

    checkout(data) {
        return new Promise((resolve, reject) => {
           const url = _API + '/payment/checkout';
           const conf = {
               headers: _HEADER()
           };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf )
                .then( res => {
                    resolve( res );
                } )
                .catch( err => {
                    reject( err );
                } );
        });
    },

    getMyPurchaseSummary() {
        return new Promise((resolve, reject) => {
            const url = _API + '/payment/getMyPurchaseSummary';
            const conf = {
                headers: _HEADER()
            };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url , {}, conf)
                .then( res => {
                    resolve( res );
                })
                .catch( err => {
                   reject( err );
                });
        })
    },

    getMyPurchaseHistory(data) {
        return new Promise((resolve, reject) => {
           const url = _API + '/payment/getMyPurchaseHistory';
           const conf = {
             headers: _HEADER()
           };

           _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url, data, conf)
               .then( res => {
                  resolve( res );
               })
               .catch( err => {
                   reject( err );
               });
        });
    },

    updatePaymentMethod(data) {
        return new Promise((resolve, reject) => {
           const url = _API + '/payment/updatePaymentMethod';
           const conf = {
               headers: _HEADER()
           }

           _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf)
               .then( res => {
                   resolve( res );
               })
               .catch( err => {
                  reject( err );
               });
        });
    },

    changeSubscription(data) {
        return new Promise((resolve, reject) => {
           const url = _API + '/payment/changeSubscription';
           const conf = {
               headers: _HEADER()
           }
           _AXIOS_HELPER( ENUM.HTTP_METHOD.PUT, url, data, conf)
               .then( res => {
                   resolve( res );
               })
               .catch( err => {
                  reject( err );
               });
        });
    },

    getSubscriptionStatus() {
        return new Promise((resolve, reject) => {
            const url = _API + '/payment/getSubscriptionStatus';
            const conf = {
                headers: _HEADER()
            };

            _AXIOS_HELPER( ENUM.HTTP_METHOD.POST, url , {}, conf)
                .then( res => {
                    resolve( res );
                })
                .catch( err => {
                    reject( err );
                });
        })
    },
}